module.exports = __webpack_public_path__ + "static/media/crunch-two.d2d30edd.svg";